import FiltersIcon from './FiltersIcon'

export default FiltersIcon
